import { render } from "./cardReturn.vue?vue&type=template&id=39d503a6"
import script from "./cardReturn.vue?vue&type=script&lang=js"
export * from "./cardReturn.vue?vue&type=script&lang=js"

import "./cardReturn.vue?vue&type=style&index=0&id=39d503a6&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__